import { createSlice, type PayloadAction } from "@reduxjs/toolkit";
import type { AppState } from "../store";
import type { GuarantorInteractive } from "../types/guarantor";

type GuarantorState = {
	possibleGuarantors: GuarantorInteractive[];
};

const initialState: GuarantorState = {
	possibleGuarantors: [],
};

const guarantorSlice = createSlice({
	name: "guarantors",
	initialState,
	reducers: {
		setPossibleGuarantors: (state, action: PayloadAction<GuarantorInteractive[]>) => {
			state.possibleGuarantors = action.payload;
		},
		resetPossibleGuarantors: () => initialState,
	},
	extraReducers: (build) => {
		build.addCase("resetStore", () => initialState);
	},
});

export const selectPossibleGuarantors = (state: AppState) => state.guarantors.possibleGuarantors;

export const isAnyGuarantorsSelected = (state: AppState) =>
	state.guarantors.possibleGuarantors.some((item) => item.checked);

export const { setPossibleGuarantors, resetPossibleGuarantors } = guarantorSlice.actions;

export default guarantorSlice.reducer;
